import React, { useCallback, useContext } from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalLoaderProps } from './types';
import { LoaderContainer } from './styles';
import PickersLoader from '../assets/loader-pickers.gif';
import PickitLoader from '../assets/loader-pickit.gif';
import { ThemeContext } from '../ThemeProvider/ThemeProvider';
import { ThemeEnum } from '../ThemeProvider/types';

const GlobalLoader: React.FC<GlobalLoaderProps> = ({ isLoading, testId }) => {
  const { actualTheme, themeName } = useContext(ThemeContext);

  const getLoader = useCallback(() => {
    if (themeName === ThemeEnum.pickers) return PickersLoader;
    return PickitLoader;
  }, [themeName]);

  if (isLoading) {
    return (
      <ThemeProvider theme={actualTheme}>
        <LoaderContainer data-testid={testId}>
          <img src={getLoader()} alt="loader" />
        </LoaderContainer>
      </ThemeProvider>
    );
  }

  return null;
};

export default GlobalLoader;
